export enum VisualState {
  Closed = 'closed',
  Closing = 'closing',
  Opening = 'opening',
  Opened = 'opened',
}
